var Init = function(){
  var $window = $(window);

  var NewsChangeFunc = function(){
    var $newsBox = $(".news-box");
    var $categorySelectContent = $(".news-select p");
    var $categorySelect = $(".news-category select");
    var selectedCategory = "";

    var CategorySelector = function(category){
      var _category = category;
      if(_category === selectedCategory){
        selectedCategory = "";
        $newsBox.css({display: ""});
        $categorySelectContent.removeClass("news-nav--selected");
        $categorySelect.val(0);
      }else{
        selectedCategory = _category;
        $categorySelectContent.each(function(){
          var __$this = $(this);
          if(__$this.data("category") === _category){
            __$this.addClass("news-nav--selected");
          }else{
            __$this.removeClass("news-nav--selected");
          }
        });
        $newsBox.each(function(){
          var __$this = $(this);
          if(
            __$this.data("category") === _category ||
            _category === ""
          ){
            __$this.css({display: ""});
          }else{
            __$this.css({display: "none"});
          }
        });

        var $options = $categorySelect.find("option");
        $options.each(function(){
          var __$this = $(this);
          if(__$this.data("category") === _category){
            __$this.prop("selected", true);
          }else{
            __$this.prop("selected", false);
          }
        });
      }

      $("html, body").stop().animate({scrollTop: 0}, 300);
    };
    var CategoryFilter = function(event){
      var _$this = $(event.currentTarget);
      var _category;
      var _option = _$this.find("option:selected").data("category");
      if(_option === void 0){
        _category = _$this.data("category");
      }else{
        _category = _option;
      }
      CategorySelector(_category);
    };
    $categorySelectContent.on("click", CategoryFilter);
    $categorySelect.on("change", CategoryFilter);
  };


  var _news = new JSONReader("#news_articles", "news");
  _news.read("../mt_output/json/news-list.json", 20, NewsChangeFunc);


};

window.addEventListener("load", Init);
